import axios from "axios";

const galeria = {
    getGaleria: (id) => axios.get(`conf-galeria/listar/${id}`),
    crearGaleria: (datos) => axios.post(`conf-galeria/crear`, datos),
    eliminarGaleria: (id) => axios.delete(`conf-galeria/eliminar/${id}`),
};

export default galeria;
